export default {
  messages: {
    en: {
      dateAvailable: 'Available {date}',
      exchangeRateWarning: {
        content: `The above amounts are indicative, based on the exchange rate the day this loan was added to the website.  The actual amounts you will receive will be based on an exchange rate at the time the repayment is returned to your account. {link}`,
        link: {
          label: `See our Help Centre for more information.`,
        },
      },
      heading: '{name} loan repayment schedule',
      showAll: 'Show all',
      table: {
        headers: {
          actual: `Actual repayments`,
          date: `Date`,
          expected: `Expected repayments`,
        },
      },
    },
  },
}
